import { message } from 'antd'
import { useAppSelector, usePayment } from '../../app/hooks'
import { isEmbedMode } from '../../utils/embedMode'

type OpenInClient = (
  vipKind: number,
  userId: string,
  groupId: string
) => 'opened' | 'unavailable' | 'unsupported'
let openInClient: OpenInClient | null = null

/**
 * 权益页的多个开通入口共享已握手的宿主能力，桥卸载后立即失效。
 * @param open - 返回客户端的受理状态
 * @returns 注销当前桥的函数
 * @example useEffect(() => registerPrivilegesPaymentHost(open), [])
 */
export function registerPrivilegesPaymentHost(open: OpenInClient): () => void {
  openInClient = open
  return () => {
    if (openInClient === open) openInClient = null
  }
}

/**
 * 由权益页卡片和吸附栏调用，嵌入时优先使用客户端已有开通弹窗。
 * @returns 开通指定档位的方法；普通 Web 和未声明能力的旧宿主沿用原弹窗
 */
export function usePrivilegesPayment(): (vipKind: number) => void {
  const { openVipByKind } = usePayment()
  const userId = useAppSelector((state) => state.main.user?.user_id ?? '')
  const groupId = useAppSelector((state) => state.group.groupId ?? '')
  return (vipKind) => {
    if (isEmbedMode()) {
      const result = openInClient?.(vipKind, userId, groupId)
      if (result === 'opened') return
      if (result === 'unavailable') {
        message.warning('团队信息已变化，请返回主界面后重试')
        return
      }
    }
    openVipByKind(vipKind, 'webVIPSummary')
  }
}
